import {getPath} from '@epic-core/common';
import {getLocalePath} from 'epic-ue-locale-mode';
import React from 'react';
import {ConnectedPage, ServerRoute} from './routes';
import ClassicRoute from '../classic/ClassicRoute';
import ErrorPage from '../pages/ErrorPage';
import PluginsPage from '../pages/PluginsPage';
import BulletTrainPage from '../pages/BulletTrainPage';
import XrPage from '../pages/XrPage';
import TrainingPage from '../pages/TrainingPage';
import TrainingDetailPage from '../pages/TrainingDetailPage';
import InstructorGuidesPage from '../pages/InstructorGuidesPage';
import GameJamPage from '../pages/GameJamPage';
import ParagonPage from '../pages/ParagonPage';
import SponsoredContentPage from '../pages/SponsoredContentPage';
import VPFieldGuidePage from '../pages/VPFieldGuidePage';
import ResourcesPage from '../pages/ResourcesPage';
import HighlightPage from '../pages/HighlightPage';
import ProgramPage from '../pages/ProgramPage';
import MaintenancePage from '../pages/MaintenancePage';
import LearnAuthPage from '../pages/LearnAuthPage';
import FastTrackPage from '../pages/FastTrackPage';
import DigitalTwinsPage from '../pages/DigitalTwinsPage';
import CmsPage from '../CmsPage';

const getEl = (el: ConnectedPage): JSX.Element => {
    return <ClassicRoute element={el} />;
};

const getRoute = (path: string, el: ConnectedPage): ServerRoute => {
    return {
        path,
        element: getEl(el),
        getInitialSharedValues: el?.getInitialSharedValues
    };
};

export const getClassicRoutes = (): ServerRoute[] => {
    const path = getPath();
    const localePath = getLocalePath();

    return [
        getRoute(`${localePath}/xr`, XrPage),
        getRoute(`${localePath}/events/:typeSlug/:title`, HighlightPage),
        getRoute(`${localePath}/digital-twins`, DigitalTwinsPage),
        getRoute(`${localePath}/educators/resources`, InstructorGuidesPage),
        getRoute(`${localePath}/guides-and-white-papers`, ResourcesPage),
        getRoute(`${localePath}/fabfreecontent`, SponsoredContentPage),
        getRoute(`${localePath}/globalgamejam`, GameJamPage),
        getRoute(`${localePath}/programs/:typeSlug/:title`, HighlightPage),
        getRoute(`${localePath}/programs/:title`, ProgramPage),
        getRoute(`${localePath}/paragon`, ParagonPage),
        getRoute(`${localePath}/lesson-plans/:title`, TrainingDetailPage),
        getRoute(`${localePath}/lesson-plans`, TrainingPage),
        getRoute(`${localePath}/vpfieldguide`, VPFieldGuidePage),
        getRoute(`${localePath}/classroom-training/:title`, TrainingDetailPage),
        getRoute(`${localePath}/bullet-train`, BulletTrainPage),
        getRoute(`${localePath}/maintenance`, MaintenancePage),
        getRoute(`${localePath}/learn-auth`, LearnAuthPage),
        getRoute(`${localePath}/fast-track`, FastTrackPage),

        //error pages
        getRoute(`${localePath}/page-not-found`, ErrorPage),
        getRoute(`${path}page-not-found`, ErrorPage),
        getRoute(`${localePath}/error-404`, ErrorPage),
        getRoute(`${path}error-404`, ErrorPage),
        getRoute(`${path}unexpectedError`, ErrorPage),
        getRoute(`${localePath}/unexpectedError`, ErrorPage),
        getRoute(`${localePath}/error-500`, ErrorPage),
        getRoute(`${path}error-500`, ErrorPage),

        //known sub directories that render the CmsPage
        getRoute(`${localePath}/previous-versions/:cmsPageSlug`, CmsPage),
        getRoute(`${localePath}/support/:cmsPageSlug`, CmsPage),
        getRoute(`${localePath}/html5/:cmsPageSlug`, CmsPage),

        getRoute(`${localePath}/qa-test/blank-template`, CmsPage),
        getRoute(`${localePath}/qa-test/blank-template/:cmsPageSlug`, CmsPage),

        //fallback to cms page
        getRoute(`${localePath}/:cmsPageSlug`, CmsPage),

        //last resort its a 404
        getRoute(`${localePath}/*`, ErrorPage)
    ];
};
